module.exports = __webpack_public_path__ + "static/img/306.4579c7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/306.png
// module id = 515
// module chunks = 3